import { DATA_MAPPER_STEP } from "../DataMapperProfileStateStore";

/** The editor routes' names (RouterStore.goTo targets). */
export const DATA_MAPPER_ROUTE = {
  profiles: "Data Mapper",
  source: "Data Mapper Source",
  library: "Data Mapper Library",
  schema: "Data Mapper Schema",
  map: "Data Mapper Map",
  transform: "Data Mapper Transform",
  lookupTables: "Data Mapper Lookup Tables",
  target: "Data Mapper Target",
  import: "Data Mapper Import",
} as const;

/** The editor steps in wizard order, for the header's step buttons. */
export const DATA_MAPPER_EDITOR_STEPS = [
  { key: "schema", label: "Schema", route: DATA_MAPPER_ROUTE.schema, step: DATA_MAPPER_STEP.schema },
  { key: "map", label: "Map", route: DATA_MAPPER_ROUTE.map, step: DATA_MAPPER_STEP.map },
  { key: "transform", label: "Transform", route: DATA_MAPPER_ROUTE.transform, step: DATA_MAPPER_STEP.transform },
] as const;

/** Every step a screen records as `lastStep`, with the route that resumes it. */
const RESUMABLE_STEPS: ReadonlyArray<{ step: number; route: string }> = [
  ...DATA_MAPPER_EDITOR_STEPS,
  { step: DATA_MAPPER_STEP.target, route: DATA_MAPPER_ROUTE.target },
  { step: DATA_MAPPER_STEP.import, route: DATA_MAPPER_ROUTE.import },
];

/**
 * Where opening a profile resumes: the screen it was left on, or the wizard's
 * Source step (the first step after choosing a profile) for a new profile or
 * a step this app has no screen for.
 */
export function routeForStep(step: number | null | undefined): string {
  return RESUMABLE_STEPS.find((s) => s.step === step)?.route ?? DATA_MAPPER_ROUTE.source;
}
